<template>
  <div id="app">
    <router-view />
    <!-- 全站常驻：合规AI助手（右下角悬浮；R2阶段按现行版本重著） -->
    <RobotAssistant />
  </div>
</template>

<script>
import RobotAssistant from "./components/RobotAssistant.vue";

export default {
  name: "App",
  components: { RobotAssistant },
};
</script>

<style lang="scss">
body {
  margin: 0;
}
</style>
